module.exports = __webpack_public_path__ + "static/assets/e795aa5c31ad4d5e3953018a802a8ad4.svg";